import React from "react";
import { EyeIcon, TrashIcon } from "@aureskonnect/react-ui";
import { Tooltip } from "@material-ui/core";
import classnames from "classnames";
import ErrorToast from "@components/Common/ErrorTost";

function ArchiveButton({
    isModeOfSaleArchived,
    isEdited,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    e,
    dataAssociate,
    t,
    isModeOfSaleUsed,
    oneShop,
    dataArchive,
    isSaleSupportArchived,
    activeModeOfSale,
    numberActive,
    numberArchived,
    setNumberActive,
    setNumberArchived,
    setSale,
    setSelectedRows,
    isLoading,
    setModalState,
}: any) {
    const isArchived = isModeOfSaleArchived;
    const isInDataArchive = dataArchive.includes(e.selectedRow.Id);
    const handleArchiveClick = ({
        isEdited,
        setIsActionsClicked,
        setActions,
        setIsEdited,
        selectedRow,
        dataAssociate,
        t,
        isModeOfSaleUsed,
    }: any) => {
        const doArchive = async () => {
            if (selectedRow.isFavorite === true) {
                ErrorToast(
                    t("Please note, you cannot archive a favorite mode of sale")
                );
            } else if (dataAssociate.length > 0) {
                ErrorToast(
                    t(
                        "Please note that you cannot archive an item assigned to stores."
                    )
                );
            } else {
                await isModeOfSaleUsed(); // call the actual archive function
            }
        };

        if (isEdited === true) {
            setIsActionsClicked((prev: any) => !prev);
            setActions(() => {
                setModalState((prev: any) => ({
                    ...prev,
                    isAddModeOfSaleClicked: false,
                }));
                setIsEdited(false);
                doArchive();
            });
        } else {
            setModalState((prev: any) => ({
                ...prev,
                isAddModeOfSaleClicked: false,
            }));
            doArchive();
        }
    };

    const handleUnarchiveClick = async ({
        selectedRow,
        oneShop,
        dataArchive,
        activeModeOfSale,
        setNumberActive,
        setNumberArchived,
        numberActive,
        numberArchived,
        setSale,
        setSelectedRows,
        t,
        isSaleSupportArchived,
    }: any) => {
        const isArchived = await isSaleSupportArchived();

        if (isArchived === true) {
            ErrorToast(
                t(
                    "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                )
            );
        } else if (dataArchive.includes(selectedRow.Id) && !oneShop) {
            setModalState((prev: any) => ({
                ...prev,
                isModalOpened: !prev.isModalOpened,
            }));
        } else {
            activeModeOfSale();
            setNumberActive(numberActive + 1);
            setNumberArchived(numberArchived - 1);
        }

        setSale(selectedRow);
        setSelectedRows([selectedRow]);
    };

    return !isArchived ? (
        <Tooltip title={t("Archive")}>
            <div>
                <TrashIcon
                    onClick={() =>
                        handleArchiveClick({
                            isEdited,
                            setIsActionsClicked,
                            setActions,
                            setIsEdited,
                            selectedRow: e.selectedRow,
                            dataAssociate,
                            ErrorToast,
                            t,
                            isModeOfSaleUsed,
                        })
                    }
                    height={25}
                    width={25}
                    fill="red"
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "pointer__clz cmn_icn_FRarchived",
                        {
                            "not-allowed-icon__clz": isArchived || isLoading,
                        },
                        oneShop ? "mr-2" : "ml-3"
                    )}
                />
            </div>
        </Tooltip>
    ) : (
        <Tooltip title={isInDataArchive && oneShop ? "" : t("Unarchive")}>
            <div>
                <EyeIcon
                    height={25}
                    width={25}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        handleUnarchiveClick({
                            selectedRow: e.selectedRow,
                            oneShop,
                            dataArchive,
                            activeModeOfSale,
                            setNumberActive,
                            setNumberArchived,
                            numberActive,
                            numberArchived,
                            setSale,
                            setSelectedRows,
                            ErrorToast,
                            t,
                            isSaleSupportArchived,
                        })
                    }
                    className={classnames(
                        "pointer__clz cmn_icn_FRunarchive",
                        {
                            "not-allowed-icon__clz":
                                isLoading || (isInDataArchive && oneShop),
                        },
                        oneShop ? "mr-2" : "ml-3"
                    )}
                />
            </div>
        </Tooltip>
    );
}

export default ArchiveButton;
